// Username/password sign-in, for environments that should not depend on Azure AD.
//
// Enabled only when REACT_APP_SIMPLE_LOGIN is "true", which is set in .env.staging
// and .env.localDev and in no other env file.
//
// NEVER set this variable to "false". Omit it instead.
//
// CRA's DefinePlugin replaces the whole `process.env` expression with one object
// literal rather than substituting each REACT_APP_* access individually, so
// `process.env.REACT_APP_SIMPLE_LOGIN === 'true'` compiles to a property lookup on
// that literal - evaluated at run time, not folded at build time. Verified in a
// production bundle: the key is absent from the object, the lookup yields undefined,
// and every guard takes the Azure path. Terser also drops the `=== 'true'` in the
// process and leaves a bare truthiness check, which is why the string "false" would
// switch this ON. Absent is the only safe way to express "off".
//
// So this code ships in every build, including production, unlike the NODE_ENV-gated
// src/azure/devAuth.js on feature/local-dev-auth-bypass, which really is stripped
// (webpack does substitute process.env.NODE_ENV individually, so that one folds).
// A NODE_ENV gate cannot work here: react-scripts build hard-codes
// NODE_ENV=production, so it would switch this off in staging, which is a build.
//
// Shipping it is not the exposure devAuth.js would have been. There are no
// credentials here - only a form and an endpoint path - and the boundary is enforced
// server-side: SimpleAuthController 404s unless SimpleAuth:Enabled is set, and
// Startup refuses to boot if it is ever enabled in Production.

import { BASE_URL } from '../api/apiConfig'

export const SIMPLE_LOGIN = process.env.REACT_APP_SIMPLE_LOGIN === 'true'

// Survives a reload so a demo is not interrupted by a refresh, but dies with the tab.
export const SIMPLE_LOGIN_STORAGE_KEY = 'simpleLoginSession'

export const loginWithPassword = async (userName, password) => {
  const response = await fetch(`${BASE_URL}/api/simpleauth/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ userName, password }),
  })

  if (!response.ok) {
    throw new Error('SIMPLE_LOGIN_FAILED')
  }

  return response.json()
}

export const readStoredSession = () => {
  try {
    const raw = sessionStorage.getItem(SIMPLE_LOGIN_STORAGE_KEY)
    return raw ? JSON.parse(raw) : null
  } catch (e) {
    return null
  }
}

export const storeSession = (session) => {
  try {
    sessionStorage.setItem(SIMPLE_LOGIN_STORAGE_KEY, JSON.stringify(session))
  } catch (e) {
    // private mode, or storage disabled - the session just will not survive a reload
  }
}

export const clearStoredSession = () => {
  try {
    sessionStorage.removeItem(SIMPLE_LOGIN_STORAGE_KEY)
  } catch (e) {
    // nothing to do
  }
}
